import React from "react";
import { useLocation } from "react-router";
import copywrite from "../../assets/svg/copywrite.svg";
import Header from "../../components/Layout/Header/Header";
import Logout from "../../Pages/Account/Logout/Logout";
import "./home.scss";
import SideBarMenu from "./SidebarMenu";

const HomeContent = ({ children }) => {
  return (
    <div className="content-scrollable">
      <div className="main-scroll-content">
        <div className="main-scroll-content-wrapper">{children}</div>
      </div>
      <Footer />
    </div>
  );
};

const Footer = () => {
  return (
    <div className="footer">
      <img src={copywrite} alt="Logo" className="footer-logo" />
      <span>HealthSy 2025. All Rights Reserved.</span>
    </div>
  );
};

const Home = ({ children }) => {
  const location = useLocation();
  const currentPath = location.pathname;
  const mainContentClass =
    currentPath === "/dashboard" || currentPath === "/"
      ? "dashboard-bg"
      : "default-bg";

  return (
    <div className="home-layout">
      <Header />
      <div className="home-body">
        <div className="sidebar-wrapper">
          <SideBarMenu />
        </div>
        <main className={`main-content ${mainContentClass}`}>
          <HomeContent>{children}</HomeContent>
        </main>
        <Logout />
      </div>
    </div>
  );
};

export default Home;
